<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
          <el-button type="success" plain @click="onExport">导出</el-button>
      </template>
    </list>
  </div>
</template>

<script>
import list from '@/components/operate/activedts/list'
import curdMixins from "@/mixins/curd";
export default {
  name: "activedts",
  mixins: [curdMixins],
  components: {
    list,
  },
  methods: {
    onExport() {
      this.$refs.list.export();
    },
  }
}
</script>

<style>
</style>